module.exports = __webpack_public_path__ + "media/images/games/35gender/comicbook-747765b8e9acd77c4198a71a00b5a055.png";